// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vd__1c43D","withoutSpace":"vd__1z927","title":"vd__2NCtK","logo":"vd__RPmCm"};